import { render, staticRenderFns } from "./blankSpace.vue?vue&type=template&id=4284b276&scoped=true&"
import script from "./blankSpace.vue?vue&type=script&lang=ts&"
export * from "./blankSpace.vue?vue&type=script&lang=ts&"
import style0 from "./blankSpace.vue?vue&type=style&index=0&id=4284b276&lang=less&scoped=true&"
import style1 from "./blankSpace.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4284b276",
  null
  
)

export default component.exports